import { useState, useEffect, useRef } from "react";
import {
  Box,
  Modal,
  Fade,
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import CustomSwitch from "../../../shared/CustomSwitch";
// import MailIcon from "@mui/icons-material/Mail";
import SelectedMessageDetails from "./SelectedMessageDetails";

import { useReactToPrint } from "react-to-print";

const style = {
  position: "absolute",
  top: "20px",
  height: "calc(100vh - 40px)",
  width: "calc(100vw - 40%)",
  marginRight: "20%",
  marginLeft: "20%",
  bgcolor: "#F8FAFB",
  border: "none",
};

/**
 *
 * @param {Object} Message Object of a selected message
 * @param {Array} messageDetails Array of a selected message details
 * @param {Object} handeeClose close modal handler
 * @returns
 */
const ViewMessageModal = ({ message, messageDetails, handleClose }) => {
  const [showOriginal, setShowOriginal] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  //Show Original handler
  const showOriginalToggler = () => {
    setShowOriginal(!showOriginal);
    showOriginal
      ? setPrintContentRef(messageRef)
      : setPrintContentRef(originalMessageRef);
  };

  //printing refs
  const messageRef = useRef(null); //component to print ref
  const originalMessageRef = useRef(null); //original message ref
  const onBeforeGetContentRef = useRef(); //a ref for a promise resolve

  const [printContentRef, setPrintContentRef] = useState(messageRef);

  //before get content to print handler (returns a promise so the print preview dialoge waits for the state of 'printing' to finish updating)
  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      setIsPrinting(true); //set printing state to true (a dependency for hidden and shown content in the print[])
      onBeforeGetContentRef.current = resolve; //to resolve the promise right after the printing state is updated
    });
  };

  //resolve onBeforeGetContent promise right after printing state is updated
  useEffect(() => {
    if (isPrinting) onBeforeGetContentRef.current();
  }, [isPrinting, onBeforeGetContentRef]);

  const handlePrint = useReactToPrint({
    content: () => printContentRef.current,
    documentTitle: message?.header?.referenceNumber,
    onBeforeGetContent:
      //const excludedElements = document.getElementsByClassName("dontPrint");
      //for (const element of excludedElements) {
      //  element.style.display = "none";
      //}
      handleOnBeforeGetContent,

    onAfterPrint: () => {
      //const excludedElements = document.getElementsByClassName("dontPrint");
      //for (const element of excludedElements) {
      //  element.style.display = "flex";
      //}
      setIsPrinting(false);
    },
  });

  return (
    <Modal
      aria-labelledby="view-message"
      aria-describedby="view-message-details"
      open={true}
      onClose={handleClose}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      // sx={{ zIndex: 10000 }}
    >
      <Fade in={true}>
        <Box sx={style}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              height: "64px",
              p: "15px",
              backgroundColor: "#050D2E",
            }}
          >
            <Grid item>
              <Typography
                sx={{ color: "#ffffff", fontSize: "1.25rem", fontWeight: 550 }}
              >
                View Message
              </Typography>
            </Grid>
            <Grid item>
              <CloseIcon
                sx={{ color: "#ffffff", cursor: "pointer" }}
                onClick={handleClose}
              />
            </Grid>
          </Grid>
          <Grid container direction="column" sx={{ p: "20px" }}>
            <Grid
              item
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item sx={{ display: "flex" }}>
                <CustomSwitch
                  value={showOriginal}
                  onChange={showOriginalToggler}
                />
                <Typography
                  sx={{
                    fontSize: ".875",
                    fontWeight: 550,
                    color: "#050D2E",
                    marginLeft: "10px",
                  }}
                >
                  Show Original (RJE)
                </Typography>
              </Grid>
              <Grid item>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <Tooltip title="print">
                    <IconButton
                      sx={{
                        background:
                          "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                        borderRadius: "5px",
                        color: "#050D2E",
                        border: "1px solid #CFD7DF",
                      }}
                      variant="solid"
                      size="small"
                      onClick={handlePrint}
                    >
                      <PrintIcon fontSize="20px" />
                    </IconButton>
                  </Tooltip>
                  {/* <Tooltip title="email">
                    <IconButton
                      sx={{
                        background:
                          "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)",
                        borderRadius: "5px",
                        color: "#050D2E",
                        border: "1px solid #CFD7DF",
                      }}
                      variant="solid"
                      size="small"
                    >
                      <MailIcon fontSize="20px" />
                    </IconButton>
                  </Tooltip> */}
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              container
              sx={{
                bgcolor: "#ffffff",
                marginTop: "20px",
                height: "calc(100vh - 200px)",
                overflowY: "scroll",
                border: "1px solid #D3D8E3",
                p: "20px",
              }}
            >
              {showOriginal ? (
                <div className="pre-line" ref={originalMessageRef}>
                  {message.detail.rjeFormat}
                </div>
              ) : (
                <SelectedMessageDetails
                  messageDetails={messageDetails}
                  isPrinting={isPrinting}
                  ref={messageRef}
                />
              )}
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ViewMessageModal;
